<template>
  <b-container>
    <b-form>
      <b-col class="text-left">Par: {{ analysis.Par }}</b-col>
    </b-form>
    <b-form-row style="line-height: 20px">
      <b-col></b-col>
      <b-col v-html="suitHtml.spades"></b-col>
      <b-col v-html="suitHtml.hearts"></b-col>
      <b-col v-html="suitHtml.diams"></b-col>
      <b-col v-html="suitHtml.clubs"></b-col>
      <b-col v-html="suitHtml.nt"></b-col>
    </b-form-row>
    <b-form-row>
      <b-col>N</b-col>
      <b-col>{{ parseAnalysis(analysis.North.Spades) }}</b-col>
      <b-col>{{ parseAnalysis(analysis.North.Hearts) }}</b-col>
      <b-col>{{ parseAnalysis(analysis.North.Diams) }}</b-col>
      <b-col>{{ parseAnalysis(analysis.North.Clubs) }}</b-col>
      <b-col>{{ parseAnalysis(analysis.North.NoTrump) }}</b-col>
    </b-form-row>
    <b-form-row>
      <b-col>E</b-col>
      <b-col>{{ parseAnalysis(analysis.East.Spades) }}</b-col>
      <b-col>{{ parseAnalysis(analysis.East.Hearts) }}</b-col>
      <b-col>{{ parseAnalysis(analysis.East.Diams) }}</b-col>
      <b-col>{{ parseAnalysis(analysis.East.Clubs) }}</b-col>
      <b-col>{{ parseAnalysis(analysis.East.NoTrump) }}</b-col>
    </b-form-row>
    <b-form-row>
      <b-col>S</b-col>
      <b-col>{{ parseAnalysis(analysis.South.Spades) }}</b-col>
      <b-col>{{ parseAnalysis(analysis.South.Hearts) }}</b-col>
      <b-col>{{ parseAnalysis(analysis.South.Diams) }}</b-col>
      <b-col>{{ parseAnalysis(analysis.South.Clubs) }}</b-col>
      <b-col>{{ parseAnalysis(analysis.South.NoTrump) }}</b-col>
    </b-form-row>
    <b-form-row>
      <b-col>W</b-col>
      <b-col>{{ parseAnalysis(analysis.West.Spades) }}</b-col>
      <b-col>{{ parseAnalysis(analysis.West.Hearts) }}</b-col>
      <b-col>{{ parseAnalysis(analysis.West.Diams) }}</b-col>
      <b-col>{{ parseAnalysis(analysis.West.Clubs) }}</b-col>
      <b-col>{{ parseAnalysis(analysis.West.NoTrump) }}</b-col>
    </b-form-row>
    <b-form-row>
      <b-col class="text-right">
        <b-form-checkbox v-model="showTotalTricks">Mostra prese totali</b-form-checkbox>
      </b-col>
    </b-form-row>
  </b-container>
</template>

<script>
import {suitHtml, suitSymbols} from '@/lib/cardSuits';
import {mapActions, mapGetters} from "vuex";

export default {
  name: "DealAnalysis",
  props: {
    analysis: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      suitSymbols: suitSymbols
    };
  },
  computed: {
    suitHtml() {
      return suitHtml
    },
    ...mapGetters({
      _showTotalTricks: 'webApp/showTotalTricks'
    }),
    showTotalTricks: {
      get() {
        return this._showTotalTricks;
      },
      set(newValue) {
        this.changeShowTotalTricks(newValue);
      }
    }
  },
  methods: {
    ...mapActions({
      changeShowTotalTricks: 'webApp/changeShowTotalTricks',
    }),
    parseAnalysis(tricksNumber) {
      return this._showTotalTricks ? tricksNumber :
          tricksNumber < 7 ? "-" : tricksNumber - 6;
    }
  },
}
</script>

<style scoped>

</style>